module.exports = __webpack_public_path__ + "img/20200515-1.cff2e0ea.jpg";